import { createSelector } from '@ngrx/store';
import { getOffers } from './offers.selector';

export const getCurrentPlan = createSelector(
  getOffers,
  (offers) => offers.current_plan
);
